import { Alert, AlertTitle } from '@mui/material'
import React from 'react'
import AddressOcrProblemsList from '../AddressOcrProblemsList'

const AddressOcrValidationReport = ({ ocrData }) => {
  const OCR_MIN_TRIES_TO_SKIP = 2
  const validations = ocrData?.latest_try?.response_data?.validations  
  const inputData = ocrData?.latest_try?.input_data

  if (!validations) {
    return null
  }

  return (
    <Alert severity="warning" color="error">
      <AlertTitle>Comprovante de residência inválido</AlertTitle>
      <p>Os seguintes problemas foram identificados:</p>

      <AddressOcrProblemsList inputData={inputData} validations={validations} isInProspectView={true} />

      <strong>Tente novamente:</strong>
      <ul>
        <li>Edite os dados que você preencheu acima; ou</li>
        <li>Envie outro arquivo</li>
      </ul>
      <br></br>
      {ocrData.total_tries >= OCR_MIN_TRIES_TO_SKIP &&
        'Caso esteja seguro de que o arquivo enviado é válido, considere marcar a caixa abaixo. '}
    </Alert>
  )
}

export default AddressOcrValidationReport
